import _ from 'lodash';
import {url, routes} from 'oo-routes';
import moment from 'moment';
import 'moment-duration-format';

export {default as http} from './http';

import {INFANT_SIZES, GARMENT_ACCESSORY_SIZES, DISPLAY_SIZE_MAP} from 'oo-config/constants';

const KEY_NAMES = {
  8: 'BACKSPACE',
  13: 'ENTER',
  27: 'ESCAPE',
};

export function capitalize(str, word) {
  if (word) {
    return str.toLowerCase().replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    });
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Deprecated
export function getErrorMessage(err) {
  if (!err) {
    return null;
  }
  if (_.isString(err)) {
    return err;
  }
  if (err.message) {
    return err.message;
  }
  if (err.error) {
    return err = getErrorMessage(err.error);
  }
  if (err.issues) {
    return _.map(err.issues, (issue) => getErrorMessage(issue));
  } else {
    return JSON.stringify(err);
  }
}

export function formatError(err) {
  if (!err) {
    return null;
  }
  if (_.isString(err)) {
    return err;
  }
  if (err.message) {
    return err.message;
  }
  if (err.error) {
    return formatError(err.error);
  }
  if (err.issues) {
    return _.map(err.issues, (issue) => formatError(issue));
  } else {
    return JSON.stringify(err);
  }
}

export function prettyDate(date, format = 'MM/DD/YYYY') {
  return moment(new Date(date)).format(format);
}

export function prettyDuration(input, format = 'h:mm', trim = false) {
  if (input.length === 2) {
    input = moment(input[1]).diff(moment(input[0]), 'minutes');
  }
  return moment.duration(input, 'minutes').format(format, {trim});
}

export function prettyPrice(price, decimals = 2) {
  return `$${(price / 100).toFixed(decimals)}`;
}

export function toKeyName(keyCode) {
  return KEY_NAMES[keyCode] || keyCode;
}


export function relativeMousePosition(event, element) {
  let offsetLeft = 0, offsetTop = 0;
  let offsetElement = element;
  while (offsetElement.offsetParent) {
    offsetLeft += offsetElement.offsetLeft;
    offsetTop += offsetElement.offsetTop;
    offsetElement = offsetElement.offsetParent;
  }
  return {x: event.pageX - offsetLeft, y: event.pageY - offsetTop - window.pageYOffset};
}

export function modalMousePosition(event, element) {
  let offsetLeft = 0, offsetTop = 0;
  let offsetElement = element;
  while (offsetElement.offsetParent) {
    offsetLeft += offsetElement.offsetLeft;
    offsetTop += offsetElement.offsetTop;
    offsetElement = offsetElement.offsetParent;
  }
  let modalElem = document.getElementsByClassName('ui dimmer modals')[0] || {};
  return {x: event.pageX - offsetLeft, y: event.pageY - window.pageYOffset - offsetTop + (modalElem.scrollTop || 0)};
}

export function absoluteMousePosition(event, element) {
  let offsetLeft = 0, offsetTop = 0;
  let offsetElement = element;
  while (offsetElement.offsetParent) {
    offsetLeft += offsetElement.offsetLeft;
    offsetTop += offsetElement.offsetTop;
    offsetElement = offsetElement.offsetParent;
  }
  return {x: event.pageX - offsetLeft, y: event.pageY - offsetTop};
}

export function prettySize(size) {
  return DISPLAY_SIZE_MAP[size] || INFANT_SIZES[size] || GARMENT_ACCESSORY_SIZES[size] || size;
}

export function prettyNumber(number) {
  let sign = '';
  if (number < 0) {
    sign = '-';
  }
  number = Math.abs(number);
  let output = '';
  while (number >= 1000) {
    output = `${_.padLeft((number % 1000).toString(), 3, '0')},${output}`;
    number = Math.floor(number / 1000);
  }
  output = `${sign}${number},${output}`;
  return output.slice(0, output.length - 1);
}

export function prettyDesignType(type) {
  return {
    screenprint: 'Screenprint',
    dtg: 'DTG',
    case: 'Case',
    mug: 'Mug',
    poster: 'Poster',
    embr: 'Embroidery',
  }[type] || type;
}

export function restResponseCb(cb) {
  return function (err, response, responseMeta) {
    if (err) {
      return cb(err);
    }
    let meta = {};
    meta.count = parseInt(responseMeta.headers['x-sp-count']);
    meta.pages = parseInt(responseMeta.headers['x-sp-pages']);
    return cb(null, response, meta);
  };
}

export function productPrintTypes(product) {
  let printTypes = [];
  if (product.properties.screenprint) {
    printTypes.push('Screenprint');
  }
  if (product.properties.dtg) {
    printTypes.push('DTG');
  }
  if (product.properties.embr) {
    printTypes.push('Embroidery');
  }
  if (product.properties.poster) {
    printTypes.push('Poster');
  }
  if (product.properties.sublimation) {
    printTypes.push('Sublimation');
  }
  return printTypes;
}

export {default as scroll, hasScrollBar, scrollBarWidth} from './scroll';

export function numberToEnglish(n) { // for semantic ui formatting
  switch (n) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
      return "three";
    case 4:
      return "four";
    case 5:
      return "five";
    case 6:
      return "six";
    case 7:
      return "seven";
    case 8:
      return "eight";
    case 9:
      return "nine";
    case 10:
      return "ten";
    case 11:
      return "eleven";
    case 12:
      return "twelve";
    case 13:
      return "thirteen";
    case 14:
      return "fourteen";
    case 15:
      return "fifteen";
    case 16:
      return "sixteen";
  }
}

export function renderArtwork(artworkUrl) {
  return url('order', routes.order.artwork.render.artwork.base, { url: artworkUrl });
}



// WEBPACK FOOTER //
// ./~/sp-components/util/index.js